<template>
  <div class="py-2">
    <p class="text-left text-bnb-brown font-bold text-lg">Recent</p>
    <div
      class="rounded-md bg-white border p-2 shadow-lg flex space-x-2 overflow-scroll"
    >
      <p v-if="recent.length == 0" class="text-xxs text-bnb-brown">
        Recently viewed menu items will appear here...
      </p>
      <RecentItem
        class=""
        v-for="(item, index) in recent"
        :key="index"
        :index="index"
        :menuID="item"
      />
    </div>
  </div>
</template>

<script>
import RecentItem from "@/views/home/recent/RecentItem";
export default {
  components: { RecentItem },
  created() {
    if (localStorage.recent) {
      this.recent = JSON.parse(localStorage.recent);
    }
  },
  data() {
    return {
      recent: [],
    };
  },
};
</script>
